import { useState, useEffect } from 'react';
import { h as handleKeyDownEvents } from './utils-36a61e92.js';

function usePopperSelectListHelper({
  isOpen,
  anchorEl,
  popperRef,
  onClose,
  focusSelected,
  focusAnchorElDisabled
}) {
  const [focusedValue, setFocusedValue] = useState(null);
  useEffect(() => {
    if (!isOpen) {
      setFocusedValue(null);
    }
  }, [isOpen]);
  const handleFocus = (element, value) => {
    if (element) {
      element.focus();
    }
    setFocusedValue(value !== null && value !== void 0 ? value : null);
  };
  const handleEscape = () => {
    onClose === null || onClose === void 0 || onClose();
    if (!focusAnchorElDisabled) {
      handleFocus(anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.current);
    }
  };
  const handleKeyboardSelect = event => {
    if (event.target instanceof HTMLButtonElement) {
      var _event$target;
      (_event$target = event.target) === null || _event$target === void 0 || _event$target.click();
    }
    if (!focusAnchorElDisabled) {
      handleFocus(anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.current);
    }
  };
  const handleKeyDown = event => {
    if (event.target instanceof HTMLButtonElement) {
      var _popperRef$current;
      const keyedOverElement = handleKeyDownEvents(event, (_popperRef$current = popperRef.current) !== null && _popperRef$current !== void 0 ? _popperRef$current : null, handleEscape, handleKeyboardSelect);
      if (keyedOverElement && keyedOverElement instanceof HTMLButtonElement) {
        setFocusedValue(keyedOverElement.value);
      }
    }
  };
  const onPopoverElementDidMount = popoverEl => {
    if (focusSelected) {
      var _popoverEl$querySelec, _popoverEl$querySelec2;
      // focus on the selected item or the first option on the list
      const selectedEl = popoverEl === null || popoverEl === void 0 || (_popoverEl$querySelec = popoverEl.querySelector) === null || _popoverEl$querySelec === void 0 ? void 0 : _popoverEl$querySelec.call(popoverEl, '[role="option"][aria-selected="true"]');
      if (selectedEl) {
        handleFocus(selectedEl, selectedEl.getAttribute('value'));
        return;
      }
      const firstEl = popoverEl === null || popoverEl === void 0 || (_popoverEl$querySelec2 = popoverEl.querySelector) === null || _popoverEl$querySelec2 === void 0 ? void 0 : _popoverEl$querySelec2.call(popoverEl, '[role="option"]:first-child');
      if (firstEl) {
        handleFocus(firstEl, firstEl.getAttribute('value'));
      }
    }
  };
  return {
    focusedValue,
    handleKeyDown,
    onPopoverElementDidMount
  };
}

export { usePopperSelectListHelper as u };
//# sourceMappingURL=usePopperSelectListHelper-02833861.js.map
